import * as React from 'react';
import { Responsive, UIHeading1, UIHeading2, UIHeading3 } from '@cian/ui-kit';
import * as styles from './Title.css';

export const Title: React.FC<React.PropsWithChildren> = ({ children }) => (
  <div className={styles['title']}>
    <Responsive desktop>
      <UIHeading1 as="h1">{children}</UIHeading1>
    </Responsive>
    <Responsive tablet>
      <UIHeading2 as="h1">{children}</UIHeading2>
    </Responsive>
    <Responsive phone>
      <UIHeading3 as="h1">{children}</UIHeading3>
    </Responsive>
  </div>
);
